import { render, staticRenderFns } from "./UserWaitTask.vue?vue&type=template&id=5613d1a7&"
import script from "./UserWaitTask.vue?vue&type=script&lang=js&"
export * from "./UserWaitTask.vue?vue&type=script&lang=js&"
import style0 from "./UserWaitTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports